"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
document.addEventListener("DOMContentLoaded", function () {
  var Shopify = Shopify || {};
  // ---------------------------------------------------------------------------
  // Money format handler
  // ---------------------------------------------------------------------------
  Shopify.money_format = "${{amount}}";
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;
    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
  var LazyLoading = function () {
    var instance = new LazyLoad();
    function lazyBGImages() {
      var $bgImages = document.querySelectorAll('[data-bg]:not(.lazy)');
      if ($bgImages.length) {
        $bgImages.each(function () {
          $(this).addClass('lazy');
        });
      }
      instance.update();
    }
    function update() {
      lazyBGImages();
    }
    lazyBGImages();
    return {
      update: update
    };
  }();
  var SmoothScroll = function () {
    var $anchorLinks = $('a[href^="#"]').not('a[href="#"]');
    $('a[href="#"]').click(function (e) {
      e.preventDefault();
      return;
    });
    function goTo(target) {
      if (target === "" || !$(target).length) {
        return;
      }
      var scrollPos = typeof target === 'number' ? target : $(target).offset().top;
      if (window.innerWidth >= 720) {
        scrollPos -= $('header').outerHeight();
      } else {
        scrollPos -= $('header').outerHeight() * 2;
      }
      $('html, body').stop().animate({
        'scrollTop': scrollPos - 32
      }, 1200, 'swing', function () {
        if (typeof target === 'string') {
          if (window.location.hash) {
            // window.location.hash = target;
          }
        }
      });
    }
    if (window.location.hash) {
      setTimeout(function () {
        goTo(window.location.hash);
      }, 500);
    }
    if ($anchorLinks.length) {
      $anchorLinks.on('click', function (e) {
        if (!$("#" + this.hash.replace('#', '')).length) {
          return;
        }
        e.preventDefault();
        goTo(this.hash);
      });
    }
    return {
      to: goTo
    };
  }();

  //Global function to toggle simple accordions
  var Accordions = function () {
    var $accordions = $('.accordion');
    if (!$accordions.length) {
      return;
    }
    $accordions.each(function () {
      if ($(this).hasClass('active')) {
        $(this).find('.accordion__content').show();
      }
    });
    $accordions.find('.accordion__trigger').click(function (e) {
      var $this = $(this);
      var $accordion = $this.parent();
      var $content = $accordion.find('.accordion__content');
      var $siblings = $accordion.siblings();
      if ($accordion.hasClass('active')) {
        $accordion.removeClass('active');
        $content.slideUp('fast');
      } else {
        $accordion.addClass('active');
        $siblings.removeClass('active').find('.accordion__content').slideUp('fast');
        $content.slideDown('fast');
      }
    });
  }();
  var urlParams = function (strParam) {
    var objParams = {};
    function init() {
      objParams = {};
      var arrURLParams = window.location.search.replace('?', '').split('&');
      arrURLParams.map(function (val) {
        var arrPair = val.split('=');
        objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
      });
    }
    init();
    return {
      get: function get(strParam) {
        return objParams[strParam];
      },
      pull: init
    };
  }();

  //Global function top open / close lightboxes
  var PDMLightbox = function () {
    //Lightbox reset - This lightbox is empty and present on all pages
    var $lightbox = $('.pdm-lightbox--reset');

    //it's content can be filled from various sources
    //after close, the content is wiped
    var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');
    $('body').on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger', function (e) {
      e.preventDefault();
      var iframe = $(this).data('lightbox-iframe');
      if (iframe) {
        var replacement = '';
        var youtubePattern = /^(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=))([\w-]{11})(?:\S+)?$/g;
        var vimeoPattern = /^(?:https?:\/\/)?(?:www\.)?(?:player\.)?(?:vimeo\.com\/(?:channels\/\w+\/)?|(?:(?:www|player)\.)?vimeo\.com\/(?:showcase\/\w+\/)?video\/)(\d+)(?:\S+)?$/g;
        if (youtubePattern.test(iframe)) {
          classes += ' youtube-vid';
          replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/$1?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';
          iframe = iframe.replace(youtubePattern, replacement);
          console.log(iframe);
        }
        if (vimeoPattern.test(iframe)) {
          classes += ' vimeo-vid';
          replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="https://player.vimeo.com/video/$1?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';
          iframe = iframe.replace(vimeoPattern, replacement);
        }
        $lightbox_content.html('<div class="video-embed">' + iframe + '</div>');
      } else {
        if ($(this).data('lightbox-content')) {
          var content = $(this).data('lightbox-content');
        } else if ($(this).data('lightbox-target')) {
          var target = $(this).data('lightbox-target');
          var content = $('#' + target).html();
        } else {
          var content = $(this).next('.lightbox-content').html();
        }
        $lightbox_content.html(content);
      }
      var classes = $(this).data('lightbox-classes');
      $lightbox.addClass('active').addClass(classes);
    });
    function closeModal($lightbox) {
      $lightbox.removeClass('active');
      $('body').removeClass('noScroll');
      //wait before removing classes till lightbox closses
      if ($lightbox.hasClass('pdm-lightbox--reset')) {
        setTimeout(function () {
          $lightbox.find('.pdm-lightbox__content').empty();
          $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
        }, 750);
      }
    }
    function openModal($lightbox) {
      $lightbox.addClass('active');
      $('body').addClass('noScroll');
    }
    function updateModal($lightbox, $content) {
      $lightbox.find('.pdm-lightbox__content').html($content);
    }
    $('.pdm-lightbox').on('click', function (e) {
      if (e.target == this) {
        closeModal($(this));
      }
    });
    $('.pdm-lightbox__close').click(function (e) {
      e.stopPropagation();
      closeModal($(this).closest('.pdm-lightbox'));
    });
    return {
      close: closeModal,
      open: openModal,
      update: updateModal
    };
  }();
  AOS.init();
  var globalMenu = function () {
    var $menuLinks = $('a[data-menu]');
    if (!$menuLinks.length) {
      return;
    }
    var $megaMenus = $('.mega-menu');
    $menuLinks.click(function (e) {
      e.preventDefault();
      var $this = $(this);
      var menu = $this.data('menu');
      var $menu = $megaMenus.filter('[data-menu="' + menu + '"]');
      $megaMenus.removeClass('active');
      $menu.addClass('active');
      $('body').addClass('overlay blur no-scroll');
    });
    $megaMenus.find('.preheading').click(function () {
      if ($(window).width() < 960) {
        var $this = $(this);
        var menu = $this.data('menu');
        $('.menu-layer').filter('[data-menu="' + menu + '"]').addClass('active');
      }
    });
    function closeMega() {
      $('body').removeClass('overlay blur no-scroll');
      $megaMenus.removeClass('active');
      $('.site-search').fadeOut();
      $('.site-search__results').removeClass('active');
    }
    $('.menu-burger').click(function () {
      $('.gheader__menu').addClass('active');
    });
    $('.blur-overlay').click(function () {
      closeMega();
    });
    $('body.blur main').click(function () {
      closeMega();
    });
    $('body.blur footer').click(function () {
      closeMega();
    });
    $('.layer-close').click(function () {
      $('body').removeClass('overlay blur');
      $(this).closest('.menu-layer').removeClass('active');
    });
  }();
  var QtyInput = function () {
    var $qtyInputs = $('.qty-input');
    if (!$qtyInputs.length) {
      return;
    }
    var $inputs = $qtyInputs.find('input[type="text"]');
    $inputs.each(function () {
      var min = 1;
      if ($(this).data('min') != undefined) {
        min = parseInt($(this).data('min'));
      }
      if ($(this).val() > min) {
        $(this).siblings('.qty-count--minus').attr('disabled', false);
      } else {}
    });
    $('body').on('change', '.qty-input input[type="text"]', function () {
      var $this = $(this);
      var $minusBtn = $this.siblings('.qty-count--minus');
      var qty = parseInt($this.val());
      var min = 1;
      if ($this.data('min') != undefined) {
        min = parseInt($this.data('min'));
      }
      if (isNaN(qty) || qty <= min) {
        $this.val(min);
        $minusBtn.attr('disabled', true);
      } else {
        $minusBtn.attr('disabled', false);
        $this.val(qty);
      }
    });
    $('body').on('click', '.qty-count', function () {
      var operator = this.dataset.action;
      var $this = $(this);
      var $input = $this.siblings('input[type="text"]');
      var qty = parseInt($input.val());
      var min = 1;
      if ($input.data('min') != undefined) {
        min = parseInt($input.data('min'));
      }
      if (operator == 'add') {
        qty += 1;
        if (qty == min + 1) {
          $this.siblings('.qty-count--minus').attr('disabled', false);
        }
      } else {
        qty = qty <= min ? min : qty -= 1;
        if (qty == min) {
          $this.attr('disabled', true);
        }
      }
      $input.val(qty).trigger('change');
    });
  }();

  //todo replace the HTML of all QTY to use the one from this code
  var QtyInput2 = function () {
    var $qtyInputs = $('.js-qty');
    if (!$qtyInputs.length) {
      return;
    }
    var $inputs = $qtyInputs.find('.js-qty__input');
    var $countBtn = $qtyInputs.find('.js-qty__button');
    $inputs.each(function () {
      var min = 1;
      if ($(this).data('min') != undefined) {
        min = parseInt($(this).data('min'));
      }
      if ($(this).val() > min) {
        $(this).siblings('[data-action="subtract"]').attr('disabled', false);
      } else {}
    });
    $('body').on('change', '.js-qty .js-qty__input', function () {
      var $this = $(this);
      var $minusBtn = $this.siblings('[data-action="subtract"]');
      var qty = parseInt($this.val());
      var min = 1;
      if ($this.data('min') != undefined) {
        min = parseInt($this.data('min'));
      }
      if (isNaN(qty) || qty <= min) {
        $this.val(min);
        $minusBtn.attr('disabled', true);
      } else {
        $minusBtn.attr('disabled', false);
        $this.val(qty);
      }
    });
    $('body').on('click', '.js-qty__button', function () {
      var operator = this.dataset.action;
      var $this = $(this);
      var $input = $this.siblings('.js-qty__input');
      var qty = parseInt($input.val());
      var min = 1;
      if ($input.data('min') != undefined) {
        min = parseInt($input.data('min'));
      }
      if (operator == 'add') {
        qty += 1;
        if (qty == min + 1) {
          $this.siblings('[data-action="subtract"]').attr('disabled', false);
        }
      } else {
        qty = qty <= min ? min : qty -= 1;
        if (qty == min) {
          $this.attr('disabled', true);
        }
      }
      $input.val(qty).trigger('change');
    });
  }();
  function toggleSwiperClass($el) {
    $el.toggleClass('swiper');
    $el.find('.sw-wrapper').toggleClass('swiper-wrapper');
    $el.find('.sw-slide').toggleClass('swiper-slide');
    $el.find('.sw-scrollbar').toggleClass('swiper-scrollbar');
    $el.find('.sw-prev').toggleClass('swiper-button-prev');
    $el.find('.sw-next').toggleClass('swiper-button-next');
    $el.find('.sw-pagination').toggleClass('swiper-pagination');
  }
  function responsiveSwiper($el, options, breakpoint) {
    var init = false;
    var swiper;
    function swiperCard() {
      if (window.innerWidth < breakpoint) {
        if (!init) {
          init = true;
          toggleSwiperClass($el);
          swiper = new Swiper($el[0], options);
        }
      } else if (init) {
        swiper.destroy();
        init = false;
        toggleSwiperClass($el);
      }
    }
    swiperCard();
    window.addEventListener("resize", swiperCard);
  }
  var hero = function () {
    var $slider = $('.hero');
    if (!$slider.length) {
      return;
    }
    toggleSwiperClass($slider);
    var slider = new Swiper($slider[0], {
      centeredSlides: false,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      longSwipesRatio: .25,
      effect: "fade"
    });
  }();
  var latestPosts = function () {
    var $slider = $('.latest-posts__loop');
    if (!$slider.length) {
      return;
    }
    var options = {
      loop: false,
      slidesPerView: 1.5,
      spaceBetween: 16,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      }
    };
    responsiveSwiper($slider, options, 960);
  }();
  var productTestimonials = function () {
    var $slider = $('.product-testimonials__slider');
    if (!$slider.length) {
      return;
    }
    var $slider = new Swiper($slider[0], {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });
  }();
  var productImages = function () {
    var $slider = $('.mproduct__gallery');
    if (!$slider.length) {
      return;
    }
    var options = {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    };
    responsiveSwiper($slider, options, 960);
    var $zoom = $('.image-zoom');
    var $closeZoom = $('.close-zoom');
    $closeZoom.click(function () {
      $zoom.removeClass('active');
    });
    $('.product-image').click(function () {
      if ($(window).width() >= 960) {
        var $this = $(this);
        $zoom.addClass('active');
        var image = $this.data('master');
        var $container = $zoom.find('.spacer');
        $container.empty();
        $container.append('<img src="' + image + '"/>');
      }
    });
  }();
  var collection = function () {
    var $section = $('.sort-by');
    if (!$section.length) {
      return;
    }

    // Save existing sort parameters
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    // Add existing sort parameters to current URL
    document.querySelector('.sort-by').addEventListener('change', function (e) {
      var value = e.currentTarget.value;
      Shopify.queryParams.sort_by = value;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });
  }();
  var featCollection = function () {
    var $sliders = $('.featured-collection__loop');
    if (!$sliders.length) {
      return;
    }
    $sliders.each(function () {
      var _Swiper;
      var $this = $(this);
      var $slider = new Swiper($this[0], (_Swiper = {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 0,
        navigation: true
      }, _defineProperty(_Swiper, "navigation", {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }), _defineProperty(_Swiper, "scrollbar", {
        el: '.swiper-scrollbar',
        draggable: true
      }), _defineProperty(_Swiper, "breakpoints", {
        960: {
          slidesPerView: 2
        },
        1200: {
          slidesPerView: 2
        }
      }), _Swiper));
    });
  }();
  var productYMAL = function () {
    var $sliders = $('.product-ymal__loop');
    if (!$sliders.length) {
      return;
    }
    $sliders.each(function () {
      var _Swiper2;
      var $this = $(this);
      var $slider = new Swiper($this[0], (_Swiper2 = {
        slidesPerView: 1.25,
        loop: false,
        spaceBetween: 0,
        navigation: true
      }, _defineProperty(_Swiper2, "navigation", {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }), _defineProperty(_Swiper2, "scrollbar", {
        el: '.swiper-scrollbar',
        draggable: true
      }), _defineProperty(_Swiper2, "breakpoints", {
        960: {
          slidesPerView: 3
        }
      }), _Swiper2));
    });
  }();
  var StickToHeader = function () {
    function init() {
      var $el = $('.js-header-sticky');
      if (!$el.length) {
        return false;
      }
      $el.css('top', $('.gheader__main').innerHeight());
    }
    init();
    return {
      refresh: init
    };
  }();
  var imageLinks = function () {
    var $sliders = $('.image-links__loop');
    if (!$sliders.length) {
      return;
    }
    $sliders.each(function () {
      var _Swiper3;
      var $this = $(this);
      toggleSwiperClass($this);
      var $slider = new Swiper($this[0], (_Swiper3 = {
        slidesPerView: 1.75,
        loop: false,
        spaceBetween: 16,
        navigation: true
      }, _defineProperty(_Swiper3, "navigation", {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }), _defineProperty(_Swiper3, "scrollbar", {
        el: '.swiper-scrollbar',
        draggable: true
      }), _defineProperty(_Swiper3, "breakpoints", {
        960: {
          slidesPerView: 5
        }
      }), _Swiper3));
    });
  }();
  var featTesti = function () {
    var $section = $('.feat-testi');
    if (!$section.length) {
      return;
    }
    $section.each(function () {
      var $this = $(this);
      var $sliders = $this.find('.feat-testi__contents');
      var $sliders2 = $this.find('.feat-testi__images');
      toggleSwiperClass($sliders2);
      var slider2 = new Swiper($sliders2[0], {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        draggable: false
      });
      toggleSwiperClass($sliders);
      var slider = new Swiper($sliders[0], {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        thumbs: {
          swiper: slider2
        }
      });
    });
  }();
  var faqArchive = function () {
    var $nav = $('.faq-archive__nav button');
    if (!$nav.length) {
      return;
    }
    var $loops = $('.faq-archive__loop');
    $nav.click(function () {
      var $this = $(this);
      $nav.removeClass('active');
      $this.addClass('active');
      $loops.removeClass('active');
      var type = $this.data('type');
      var $currentLoop = $loops.filter('[data-type="' + type + '"]');
      $currentLoop.addClass('active');
      if ($(window).width() >= 960) {
        var top = $currentLoop.offset().top;
        $('html, body').stop().animate({
          'scrollTop': top
        });
      }
    });
  }();
  var StickyATC = function () {
    var $sticky = $('.sticky-atc');
    if (!$sticky.length) {
      return;
    }
    var lastScrollTop = 0;
    $(window).scroll(function () {
      var st = $(this).scrollTop();
      setTimeout(function () {
        if (st > lastScrollTop && st > 500) {
          $sticky.addClass('active');
        } else {
          if (st < 400) {
            $sticky.removeClass('active');
          }
        }
        lastScrollTop = st;
      }, 10);
    });
    function update(variant) {
      $sticky.find('.js-product-form__main-select').val(variant.id).trigger('change');
    }
    return {
      update: update
    };
  }();
  var productVariants = function () {
    function handleNonExistent($form) {
      var variants = window.productInfo[$form.data('handle')];
      var $groups = $form.find('.js-product-form__group');
      var $firstSelect = $groups.eq(0).find('.js-product-form__select');
      var firstOption = $firstSelect.val();
      var replaceVariant = false;
      $.each(variants, function (i, variant) {
        if (variant.option1 == firstOption) {
          replaceVariant = variant;
          console.log(variant);
          if (variant.available) {
            return false;
          }
        }
      });
      if (replaceVariant) {
        var index = 0;
        $groups.each(function () {
          index++;
          var optionSelector = 'option' + index;
          $(this).find('input[value="' + replaceVariant[optionSelector] + '"]').trigger('click');
        });
      }
    }
    function selectVariant($form) {
      var variants = window.productInfo[$form.data('handle')];
      var $atc = $form.find('[type="submit"]');
      var $groups = $form.find('.js-product-form__group');
      var $mainSelect = $form.find('.js-product-form__main-select');
      var options = [];
      $groups.each(function () {
        var $this = $(this);
        var val = $this.find('.js-product-form__select').val();
        options.push(val);
        $this.find('.js-product-form__selected-option').text(val);
      });
      var selectedVariant = false;
      $.each(variants, function (i, variant) {
        if (variant.option1 == options[0] && variant.option2 == options[1] && variant.option3 == options[2]) {
          selectedVariant = variant;
          return false;
        }
      });
      var atcText = $atc.data('text') + ' - ';
      if (selectedVariant) {
        console.log(selectedVariant);
        $mainSelect.val(selectedVariant.id);
        if ($form.hasClass('js-product-form--main')) {
          window.history.replaceState(null, null, '?variant=' + selectedVariant.id);
        }
        if (selectedVariant.available) {
          $atc.attr('disabled', false);
          $atc.text(atcText);
          $atc.append('<span class="price">' + Shopify.formatMoney(selectedVariant.price, '${{amount_no_decimals}}') + '</span>');
        } else {
          $atc.attr('disabled', true);
          $atc.text('Sold Out');
        }

        //do other theme specific things after a variant is selected
        //change image slide, update price etc...
        //selectedVariant is a object including all of its information that you may need

        var $parent = $form.closest('.js-product-container');
        var $price = $parent.find('.js-product-price');
        $price.text(Shopify.formatMoney(selectedVariant.price, '${{amount_no_decimals}}'));
        var $variantTitle = $parent.find('.js-variant-title');
        if ($variantTitle.length) {
          $variantTitle.text(' - ' + selectedVariant.title);
        }
        var $slider = $parent.find('.product-gallery .swiper');
        if ($slider.length && selectedVariant.featured_image) {
          var image = selectedVariant.featured_image.src;
          var newSlide = $slider.find('[data-master="' + image + '"]').data('index');
          var swiper = $slider[0].swiper;
          swiper.slideTo(newSlide, 0);
        }
        $parent.find('.product-image').eq(0).find('img').attr('src', selectedVariant.featured_image.src);
        if ($form.hasClass('js-product-form--main')) {
          StickyATC.update(selectedVariant);
        }
      } else {
        handleNonExistent($form);
      }
    }
    function updateOptionsInSelector(selectorIndex, $form, allOptionsMap, inStockOptionsMap) {
      var key, $select;
      switch (selectorIndex) {
        case 0:
          key = 'root';
          $select = $form.find('.js-product-form__group:eq(0) .js-product-form__select');
          break;
        case 1:
          key = $form.find('.js-product-form__group:eq(0) .js-product-form__select').val();
          $select = $form.find('.js-product-form__group:eq(1) .js-product-form__select');
          break;
        case 2:
          key = $form.find('.js-product-form__group:eq(0) .js-product-form__select').val();
          key += ' / ' + $form.find('.js-product-form__group:eq(1) .js-product-form__select').val();
          $select = $form.find('.js-product-form__group:eq(2) .js-product-form__select');
      }
      var availableOptions = allOptionsMap[key];
      var inStockOption = inStockOptionsMap[key];
      $select.find('option').each(function (i, option) {
        var $this = $(this);
        var value = $this.val();
        var $radio = $this.closest('.js-product-form__group').find('input[type="radio"][value="' + value + '"]');
        if (availableOptions && availableOptions.includes(value)) {
          $this.attr('disabled', false);
          $radio.attr('disabled', false);
          if (inStockOption && inStockOption.includes(value)) {
            $this.text($this.val());
            $this.removeClass('oos');
            $radio.removeClass('oos');
          } else {
            $this.text($this.val() + ' (Soldout)');
            $this.addClass('oos');
            $radio.addClass('oos');
          }
        } else {
          $this.text($this.val());
          $this.attr('disabled', true);
          $radio.attr('disabled', true);
        }
      });
    }
    function linkOptionSelectors($form) {
      var variants = window.productInfo[$form.data('handle')];
      var Shopify = Shopify || {};
      Shopify.arrayIncludes = function (e, t) {
        for (var n = 0; n < e.length; n++) if (e[n] == t) return !0;
        return !1;
      }, Shopify.uniq = function (e) {
        for (var t = [], n = 0; n < e.length; n++) Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
        return t;
      };
      var allOptionsMap = {};
      var inStockOptionsMap = {};
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var key;
        if (variant) {
          allOptionsMap.root = allOptionsMap.root || [];
          allOptionsMap.root.push(variant.option1);
          allOptionsMap.root = Shopify.uniq(allOptionsMap.root);
          if (variant.options.length > 1) {
            key = variant.option1;
            allOptionsMap[key] = allOptionsMap[key] || [];
            allOptionsMap[key].push(variant.option2);
            allOptionsMap[key] = Shopify.uniq(allOptionsMap[key]);
          }
          if (variant.options.length === 3) {
            key = variant.option1 + ' / ' + variant.option2;
            allOptionsMap[key] = allOptionsMap[key] || [];
            allOptionsMap[key].push(variant.option3);
            allOptionsMap[key] = Shopify.uniq(allOptionsMap[key]);
          }
        }
        if (variant.available) {
          inStockOptionsMap.root = inStockOptionsMap.root || [];
          inStockOptionsMap.root.push(variant.option1);
          inStockOptionsMap.root = Shopify.uniq(inStockOptionsMap.root);
          if (variant.options.length > 1) {
            key = variant.option1;
            inStockOptionsMap[key] = inStockOptionsMap[key] || [];
            inStockOptionsMap[key].push(variant.option2);
            inStockOptionsMap[key] = Shopify.uniq(inStockOptionsMap[key]);
          }
          if (variant.options.length === 3) {
            key = variant.option1 + ' / ' + variant.option2;
            inStockOptionsMap[key] = inStockOptionsMap[key] || [];
            inStockOptionsMap[key].push(variant.option3);
            inStockOptionsMap[key] = Shopify.uniq(inStockOptionsMap[key]);
          }
        }
      }
      updateOptionsInSelector(0, $form, allOptionsMap, inStockOptionsMap);
      if (variants[0].options.length > 1) updateOptionsInSelector(1, $form, allOptionsMap, inStockOptionsMap);
      if (variants[0].options.length === 3) updateOptionsInSelector(2, $form, allOptionsMap, inStockOptionsMap);
      $form.find('.js-product-form__group:eq(0) .js-product-form__select').change(function () {
        updateOptionsInSelector(1, $form, allOptionsMap, inStockOptionsMap);
        if (variants[0].options.length === 3) updateOptionsInSelector(2, $form, allOptionsMap, inStockOptionsMap);
        return true;
      });
      $form.find('.js-product-form__group:eq(1) .js-product-form__select').change(function () {
        if (variants[0].options.length === 3) updateOptionsInSelector(2, $form, allOptionsMap, inStockOptionsMap);
        return true;
      });
    }
    function init($form) {
      function handleSelectChange($select) {
        var $form = $select.closest('form');
        linkOptionSelectors($form);
        selectVariant($form);
      }
      $form.on('change', '.js-product-form__select', function () {
        handleSelectChange($(this));
      });
      $form.on('change', '.js-product-form__button', function () {
        var $this = $(this);
        var $select = $this.closest('.js-product-form__group').find('.js-product-form__select');
        $select.val($this.val());
        handleSelectChange($select);
      });
      var $firstSelect = $form.find('.js-product-form__select').eq(0);
      $firstSelect.trigger('change');
    }
    var $forms = $('.js-product-form');
    $forms.each(function () {
      var $form = $(this);
      init($form);
    });
    return {
      init: init
    };
  }();
  var shopCart = function (updates) {
    var $cart = $('section.cart');
    var $cartItemContainer = $cart.find('.cart__items');
    var $cartEmptyContainer = $cart.find('.cart__empty');
    var $cartActiveContainer = $cart.find('.cart__active');
    function open() {
      $cart.addClass('active');
    }
    function close() {
      $cart.removeClass('active');
    }
    function refresh() {
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        type: "get",
        success: function success(res) {
          var items = res.items;
          $cartItemContainer.empty();
          $.each(items, function (i, item) {
            console.log(item);
            var image = item.featured_image.url;
            var skeleton = $cart.find('.cart-card--skeleton').clone().removeClass('cart-card--skeleton')[0].outerHTML;
            skeleton = skeleton.replaceAll('||item.id||', item.variant_id);
            skeleton = skeleton.replaceAll('||item.title||', item.product_title);
            skeleton = skeleton.replaceAll('||item.price||', Shopify.formatMoney(item.price, '${{amount}}'));
            skeleton = skeleton.replaceAll('||item.image||', image);
            skeleton = skeleton.replaceAll('||item.quantity||', item.quantity);
            skeleton = skeleton.replaceAll('||item.index||', i + 1);
            var variants = '';
            if (!item.product_has_only_default_variant) {
              $.each(item.options_with_values, function (i, option) {
                variants = variants + '<li>' + option.name + ': ' + option.value + '</li>';
              });
            }
            skeleton = skeleton.replaceAll('||item.variants||', variants);
            $cartItemContainer.append(skeleton);
          });
          if (res.items.length) {
            $cartEmptyContainer.removeClass('active');
            $cartActiveContainer.addClass('active');
          } else {
            $cartEmptyContainer.addClass('active');
            $cartActiveContainer.removeClass('active');
          }
          open();
        },
        error: function error(res) {
          console.log(res);
          open();
        }
      });
    }
    function remove(updates) {
      // console.log(updates);
      $.ajax({
        url: window.Shopify.routes.root + 'cart/update.js',
        type: "post",
        data: {
          updates: updates
        },
        success: function success(res) {
          refresh();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    function update(updates) {
      // console.log(updates);
      $.ajax({
        url: window.Shopify.routes.root + 'cart/change.js',
        type: "post",
        data: updates,
        success: function success(res) {
          console.log('cart updated');
          // console.log(res);
          // refresh();
        },

        error: function error(res) {
          console.log(res);
        }
      });
    }
    function add(updates) {
      $.ajax({
        url: window.Shopify.routes.root + 'cart/add.js',
        type: "post",
        data: {
          items: updates
        },
        success: function success(res) {
          refresh();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    return {
      add: add,
      open: open,
      close: close,
      refresh: refresh,
      remove: remove,
      update: update
    };
  }();
  var Cart = function () {
    var $cart = $('section.cart');
    var $cartIcon = $('.menu-icon--cart');
    var $cartClose = $('.cart__close');
    $cartClose.click(function () {
      shopCart.close();
    });
    $cart.on('click', function (e) {
      if (e.target == this) {
        shopCart.close();
      }
    });
    $cartIcon.click(function (e) {
      e.preventDefault();
      shopCart.open();
    });
    $('body').on('click', '.cart-card__remove', function (e) {
      e.preventDefault();
      var $card = $(this).closest('.cart-card');
      var id = parseInt($card.data('id'));
      var item = {};
      item[id] = 0;
      shopCart.remove(item);
    });
    $('body').on('change', '[name="updates[]"]', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $card = $this.closest('.cart-card');
      var id = parseInt($card.data('id'));
      var item = {};
      item['id'] = id;
      item['quantity'] = $this.val();
      shopCart.update(item);
    });
    var openCartParam = urlParams.get('cart');
    if (openCartParam == 'open') {
      shopCart.open();
    }
  }();
  var AddToCartForm = function () {
    var $atc = $('form[action="/cart/add"]');
    if (!$atc.length) {
      return;
    }
    $atc.submit(function (e) {
      e.preventDefault();
      var $this = $(this);
      var item = {};
      item.id = $this.find('[name="id"]').val();
      item.quantity = 1;
      if ($this.find('[name="quantity"]')) {
        item.quantity = $this.find('[name="quantity"]').val();
      }
      var items = [item];
      shopCart.add(items);
    });
  }();
  var predictiveSearch = function () {
    var $search = $('.site-search');
    var $searchForm = $('.site-search__bar form');
    var $searchBox = $('.site-search__bar input#search');
    var $searchIcon = $('.menu-icon--search');
    var $searchClose = $('.close-search');
    var $searchResults = $('.site-search__results');
    $searchClose.click(function () {
      $('body').removeClass('no-scroll blur');
      $search.fadeOut(function () {
        $searchBox.val('');
        $searchResults.removeClass('active');
      });
    });
    $searchIcon.click(function () {
      $search.fadeIn();
      $('body').addClass('no-scroll blur');
    });
    function ajaxSearch(terms) {
      console.log('search initiated');
      $.ajax({
        url: '/search/suggest',
        type: "GET",
        data: {
          q: terms,
          section_id: 'header',
          // resources[type]: 'query,product,collection,page,article',
          'resources[type]': 'product,page,article'
        },
        success: function success(res) {
          // console.log('success');
          // console.log(res);
          $searchResults.html($(res).find('#predictive-search-results').html());
          $searchResults.addClass('active');
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    $searchForm.submit(function (e) {
      e.preventDefault();
      ajaxSearch($searchBox.val());
    });
    $searchBox.keyup(function () {
      ajaxSearch($searchBox.val());
    });
  }();
  AOS.refresh();
});